import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationSurveyCreated = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новый опрос</div>
            <div className={'vm-notification__description'}>
                Добавлен новый опрос <UiNavLink to={ROUTES.SURVEY(notification.data.survey.id)} onClick={onClose}>{notification.data.survey.name}</UiNavLink>
            </div>
        </div>
    );
});
